<template>
  <section class="fullscreen-section location-section" ref="section">
    <div class="location-content">
      <!-- 타이틀 -->
      <div class="title-area">
        <p class="sub-label">LOCATION</p>
        <h2 class="section-title">Contact Us</h2>
      </div>

      <!-- 지도 두 개 나란히 -->
      <div class="maps-container">
        <!-- 현장 -->
        <div class="map-card" @mouseenter="activeCard = 0" @mouseleave="activeCard = null">
          <div class="map-image" :class="{ active: activeCard === 0 }">
            <!-- 애니메이션 라인들 -->
            <div class="border-lines">
              <div class="line line-top"></div>
              <div class="line line-right"></div>
              <div class="line line-bottom"></div>
              <div class="line line-left"></div>
            </div>
            <img :src="require('@/assets/location1.png')" alt="현장 위치 지도" />
          </div>
          <div class="map-info">
            <span class="info-label">현 장</span>
            <p class="info-address">경상북도 구미시 산동읍 동곡리 산60-3번지</p>
          </div>
          <div class="map-buttons">
            <a href="https://map.naver.com/v5/search/경상북도 구미시 산동읍 동곡리 산60-3번지" target="_blank" class="map-btn naver">
              <span class="btn-icon">N</span>
              네이버 지도보기
            </a>
            <a href="https://map.kakao.com/link/search/경상북도 구미시 산동읍 동곡리 산60-3번지" target="_blank" class="map-btn kakao">
              <span class="btn-icon">K</span>
              카카오 지도보기
            </a>
          </div>
        </div>

        <!-- 주택전시관 -->
        <div class="map-card" @mouseenter="activeCard = 1" @mouseleave="activeCard = null">
          <div class="map-image" :class="{ active: activeCard === 1 }">
            <!-- 애니메이션 라인들 -->
            <div class="border-lines">
              <div class="line line-top"></div>
              <div class="line line-right"></div>
              <div class="line line-bottom"></div>
              <div class="line line-left"></div>
            </div>
            <img :src="require('@/assets/location2.png')" alt="주택전시관 위치 지도" />
          </div>
          <div class="map-info">
            <span class="info-label">주택전시관</span>
            <p class="info-address">경상북도 구미시 신평동 326</p>
          </div>
          <div class="map-buttons">
            <a href="https://map.naver.com/v5/search/경상북도 구미시 신평동 326" target="_blank" class="map-btn naver">
              <span class="btn-icon">N</span>
              네이버 지도보기
            </a>
            <a href="https://map.kakao.com/link/search/경상북도 구미시 신평동 326" target="_blank" class="map-btn kakao">
              <span class="btn-icon">K</span>
              카카오 지도보기
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LocationSection',
  data() {
    return {
      activeCard: null
    }
  },
  methods: {
    getSection() {
      return this.$refs.section
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;500&display=swap');

.fullscreen-section {
  width: 100%;
  height: 100vh;
  min-height: 100vh;
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow: visible;
  background: #f8f8f8;
  padding-top: 120px;
}

.location-content {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 60px;
}

/* 타이틀 */
.title-area {
  text-align: center;
  margin-bottom: 60px;
}

.sub-label {
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 4px;
  color: var(--main-color1);
  margin-bottom: 10px;
}

.section-title {
  font-family: 'Cormorant Garamond', serif;
  font-size: 56px;
  font-weight: 300;
  color: #1a1a1a;
  letter-spacing: 3px;
  font-style: italic;
}

/* 지도 컨테이너 */
.maps-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 50px;
}

.map-card {
  background: #fff;
  text-align: center;
}

/* 지도 이미지 */
.map-image {
  position: relative;
  width: 100%;
  height: 280px;
  background: #e8e8e8;
  overflow: visible;
  padding: 15px;
}

.map-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: grayscale(80%);
  opacity: 0.8;
  transition: all 0.5s ease;
}

.map-image.active img {
  filter: grayscale(0%);
  opacity: 1;
}

/* 애니메이션 라인들 */
.border-lines {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 10;
}

.line {
  position: absolute;
  background: var(--main-color1);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.map-image.active .line {
  opacity: 1;
}

.line-top {
  top: 0;
  left: 0;
  height: 2px;
  width: 0;
  transition: width 0.6s ease;
}

.line-right {
  top: 0;
  right: 0;
  width: 2px;
  height: 0;
  transition: height 0.6s ease;
}

.line-bottom {
  bottom: 0;
  left: 0;
  height: 2px;
  width: 0;
  transition: width 0.6s ease;
}

.line-left {
  bottom: 0;
  left: 0;
  width: 2px;
  height: 0;
  transition: height 0.6s ease;
}

.map-image.active .line-top {
  width: 100%;
}

.map-image.active .line-right {
  height: 100%;
}

.map-image.active .line-bottom {
  width: 100%;
}

.map-image.active .line-left {
  height: 100%;
}

.map-marker {
  position: absolute;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  z-index: 5;
}

.map-marker.site {
  top: 40%;
  left: 35%;
  background: var(--main-color1);
}

.map-marker.model {
  top: 50%;
  left: 45%;
  background: #2c5aa0;
}

/* 지도 정보 */
.map-info {
  padding: 25px 0;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.info-label {
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  padding-right: 20px;
  border-right: 1px solid #ddd;
}

.info-address {
  font-size: 14px;
  color: #666;
  margin: 0;
}

/* 지도 버튼 */
.map-buttons {
  display: flex;
  margin-top: 20px;
}

.map-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px 20px;
  font-size: 13px;
  text-decoration: none;
  transition: all 0.3s ease;
  border: 1px solid #ddd;
}

.map-btn.naver {
  background: #03c75a;
  border-color: #03c75a;
  color: #fff;
}

.map-btn.kakao {
  background: #fff;
  border-color: #ddd;
  color: #333;
}

.map-btn.naver:hover {
  background: #02b350;
}

.map-btn.kakao:hover {
  background: #f5f5f5;
}

.btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  font-size: 11px;
  font-weight: 700;
  border-radius: 3px;
}

.map-btn.naver .btn-icon {
  background: #fff;
  color: #03c75a;
}

.map-btn.kakao .btn-icon {
  background: #fee500;
  color: #3c1e1e;
}

/* 반응형 */
@media (max-width: 1200px) {
  .location-content {
    padding: 0 40px;
  }
  .maps-container {
    gap: 40px;
  }
  .section-title {
    font-size: 48px;
  }
}

@media (max-width: 1024px) {
  .fullscreen-section {
    padding-top: 100px;
  }
  .maps-container {
    grid-template-columns: 1fr;
    max-width: 550px;
    margin: 0 auto;
  }
  .section-title {
    font-size: 42px;
  }
}

@media (max-width: 768px) {
  .fullscreen-section {
    padding-top: 80px;
  }
  .location-content {
    padding: 0 24px;
  }
  .title-area {
    margin-bottom: 40px;
  }
  .section-title {
    font-size: 36px;
  }
  .map-image {
    height: 220px;
    padding: 10px;
  }
  .map-info {
    flex-direction: column;
    gap: 8px;
    padding: 20px 0;
  }
  .info-label {
    border-right: none;
    padding-right: 0;
  }
  .map-buttons {
    flex-direction: column;
  }
  .map-btn {
    padding: 12px;
  }
}

@media (max-width: 480px) {
  .fullscreen-section {
    padding-top: 60px;
  }
  .section-title {
    font-size: 30px;
  }
  .map-image {
    height: 180px;
  }
  .info-address {
    font-size: 13px;
  }
  .map-btn {
    font-size: 12px;
  }
}
</style>
